import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    today: string;
    yesterday: string;
    formattedDate: (displayDate: Date) => string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Label for today's date group */
            today: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "groupByDateFormatted.today?c=1j9aq04ad7nrh", defaultMessage: "Today" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for yesterday's date group */
            yesterday: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "groupByDateFormatted.yesterday?c=1inov86oawz3u", defaultMessage: "Yesterday" }));
                },
                enumerable: true,
                configurable: true
            },
            formattedDate: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (displayDate: Date): string => __intl__.intl().formatMessage({ id: "groupByDateFormatted.formattedDate?c=3k644jhwhoy6v", defaultMessage: "{displayDate, date, medium}" }, { displayDate: displayDate }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
